export default __webpack_public_path__ + "static/media/rocket.bd4d3a92.svg";